

const APP_LINKS = {
    PLAY_STORE_URL: "https://play.google.com/store/apps/details?id=com.kompress.aurelia",
    APP_STORE_URL: "https://apps.apple.com/us/app/kompress-ai/id6754503132",
    WEB_URL: "https://app.kompress.ai/"
}

export default APP_LINKS;